import React, {useState} from "react";

import {InboxOutlined} from "@ant-design/icons";
import {Auth} from "@digatex/digatex-ui-lib";
import {Form, Input, message, Modal, Spin, Tabs, Upload} from "antd";

import api from "../../api";
import {properties} from "../../properties";

const {Dragger} = Upload;
const {TextArea} = Input;
const {TabPane} = Tabs;

export function ImportScopeModal({isModalVisible, setIsModalVisible, projectId, onFinish, spin, setLoading}) {
	const [form] = Form.useForm();
	const [activeTab, setActiveTab] = useState("file");
	const [fileList, setFileList] = useState([]);

	const handleCancel = () => {
		form.resetFields();
		setFileList([]);
		setActiveTab("file");
		setIsModalVisible(false);
	};

	const handleOk = () => {
		form.validateFields()
			.then(values => {
				setLoading(true);

				const payload = {
					name: values.name,
					description: values.description,
				};

				if (activeTab === "file") {
					if (!fileList.length) {
						message.error("Please upload a file first!");
						setLoading(false);
						return;
					}

					payload.filename = fileList[0].name;
				} else {
					if (!values.materialsText) {
						message.error("Please enter materials!");
						setLoading(false);
						return;
					}
					const materials = values.materialsText
						.split(/[\n,]+/)
						.map(s => s.trim())
						.filter(s => s.length > 0);

					if (materials.length === 0) {
						message.error("No valid materials found!");
						setLoading(false);
						return;
					}
					payload.materials = materials;
				}

				api.post(`/projects/${projectId}/scopes/import`, payload)
					.then(() => {
						message.success("Scope imported successfully");
						handleCancel();
						onFinish();
					})
					.catch(err => {
						console.error(err);
					})
					.finally(() => {
						setLoading(false);
					});
			})
			.catch(info => {
				console.log("Validate Failed:", info);
			});
	};
	const uploadProps = {
		name: "file",
		multiple: false,
		accept: ".xlsx, .xls",
		action: `${properties.apiUrl}/api/projects/${projectId}/scopes/import/save_file`,
		headers: Auth.headers(),
		fileList: fileList,
		beforeUpload: file => {
			const isExcel =
				file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
				file.type === "application/vnd.ms-excel" ||
				file.name.endsWith(".xlsx") ||
				file.name.endsWith(".xls");

			if (!isExcel) {
				message.error(`${file.name} is not a valid Excel file`);
				return Upload.LIST_IGNORE;
			}
			return true;
		},
		onChange(info) {
			const {status} = info.file;
			let newFileList = [...info.fileList];

			newFileList = newFileList.slice(-1);

			if (status === "done") {
				message.success(`${info.file.name} file uploaded successfully.`);
			} else if (status === "error") {
				message.error(`${info.file.name} file upload failed.`);
			}
			setFileList(newFileList);
		},
		onRemove: () => {
			setFileList([]);
		},
	};

	return (
		<Modal
			title="Import Scope"
			open={isModalVisible}
			onOk={handleOk}
			onCancel={handleCancel}
			confirmLoading={spin}
			width={600}
			destroyOnClose>
			<Spin spinning={spin}>
				<Form form={form} layout="vertical">
					<Form.Item
						name="name"
						label="Scope Name"
						rules={[{required: true, message: "Please enter a scope name"}]}>
						<Input placeholder="Enter scope name" />
					</Form.Item>

					<Form.Item name="description" label="Scope Description">
						<TextArea rows={2} placeholder="Optional description" />
					</Form.Item>

					<Tabs activeKey={activeTab} onChange={setActiveTab} type="card">
						<TabPane tab="Upload Excel" key="file">
							<Form.Item label="Excel File">
								<Dragger {...uploadProps}>
									<p className="ant-upload-drag-icon">
										<InboxOutlined />
									</p>
									<p className="ant-upload-text">Click or drag file to this area to upload</p>
									<p className="ant-upload-hint">Support for a single Excel file</p>
								</Dragger>
							</Form.Item>
						</TabPane>

						<TabPane tab="Paste Materials" key="text">
							<Form.Item
								name="materialsText"
								label="List of Materials"
								help="Separate materials by new line or comma">
								<TextArea rows={8} placeholder={`10101010\n10101020\n...`} />
							</Form.Item>
						</TabPane>
					</Tabs>
				</Form>
			</Spin>
		</Modal>
	);
}
